import {useTranslation} from 'react-i18next';

import NodeEditorLayout from '../NodeEditorLayout';
import {NodeEditorV2Props} from '../types';

/** FINISH ("Stop") — nothing to configure; the dialog edits the label and says what the step is. */
const FinishEditorV2 = (_props: NodeEditorV2Props) => {
    const {t} = useTranslation();

    return (
        <NodeEditorLayout
            state={'configured'}
            summary={t('The run stops here. Nothing can be connected below this step.')}
        >
            {null}
        </NodeEditorLayout>
    );
};

export default FinishEditorV2;
